export default "__VITE_ASSET__19ab58a0__"